<template>
	<div class="main-contents display">
		<div class="tit">
			<template>블로그 노출 관리</template>
		</div>
		<div class="search-box main-display-search">
			<InputComp title="제목" v-model="input.searchStr" @keyup.enter="getList('1')"/>
			<img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getList('1')">
			<div class="sub_btn" @click="goDetail(false)">+ 등록</div>
			<div class="sub_btn dl" @click="setBlogStatus('del')">삭제</div>
			<div class="sub_btn end" @click="setBlogStatus('off')">노출종료</div>
		</div>
		<!-- 블로그 리스트 -->
		<div class="Board type3">
			<table class="Board_type3 admin">
				<colgroup>
					<col width="3%">
					<col width="3%">
					<col width="30%">
					<col width="12%">
					<col width="12%">
					<col width="30%">
					<col width="10%">
				</colgroup>
				<thead>
					<tr>
						<th><SelectComp type="yn" :value="Object.keys(checks).length != 0 && Object.keys(checks).length == list.length ? 'Y':'N'" @change="checkAll()"/></th>
						<th>순서</th>
						<th>제목</th>
						<th>시작</th>
						<th>종료</th>
						<th>미리보기</th>
						<th>상태</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="!list || list.length == 0">
						<!-- 관련내용 없을 경우 -->
						<td colspan="7" class="none">등록된 블로그 목록이 없습니다.</td>
					</tr>
					<!-- 최대 25건 조회 -->
					<tr v-else v-for="(item, idx) in list" :key="item.blogSeq">
						<td class="score"><SelectComp type="yn" :value="checks[item.blogSeq] ? 'Y':'N'" @change="checkItem(item)"/></td>
						<td class="score">{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (idx + 1)}}</td>
						<td class="score" :class="{done:item.applyState != '0'}">{{item.blogTitle}}</td>
						<td class="score" :class="{done:item.applyState != '0'}">{{item.applyStartDate | date('yyyy. MM. dd / HH:mm')}}</td>
						<td class="score" :class="{done:item.applyState != '0'}">{{item.applyEndDate | date('yyyy. MM. dd / HH:mm')}}</td>
						<td class="score banner">
							<ImageComp v-if="item.blogImgFileSeq" :src="'/api/main/bnr/blogImg?blogSeq='+item.blogSeq" alt="블로그이미지" />
							<span v-else :class="{done:item.applyState != '0'}">등록된 이미지가 없습니다</span>
						</td>
						<td class="score">
							<div class="bn_btn" @click="goDetail(item)">수정</div>
							<div class="bn_btn" @click="delBlog(item)">삭제</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<!-- 페이징부분 -->
		<paging-comp :pageInfo="pageInfo" @page-click="goPage"/>
	</div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';
export default {
	components: { pagingComp },
	data() {
		return {
			input:{
				searchStr: '',
				pageIndex: 1,
			},
			list: [],
			checks:{},
			pageInfo : {},
		};
	},
	beforeMount(){
		this.getList();
	},
	methods : {
        getList(div, isScroll = false){

			if(div) this.input.pageIndex = 1;

            this.$.httpPost('/api/main/bnr/getBlogList', this.input)
                .then(res => {
					this.checks = {};
                    this.list = res.data.list;
                    this.pageInfo = res.data.pageInfo;
                    if(isScroll) {
						window.scroll(0, 0);
					}
                }).catch(this.$.httpErrorCommon);
        },
		goPage(page){
			this.input.pageIndex = page;
			this.getList();
		},
		goDetail(item){
			var query = {}
			if(item) query.blogSeq = item.blogSeq;

			this.$router.push({name: 'MAN906M02', query});
		},
		checkItem(item){
			var blogSeq = item.blogSeq;
			if(this.checks[blogSeq]){
				delete this.checks[blogSeq];
			} else {
				this.checks[blogSeq] = item;
			}
			this.$forceUpdate();
		},
		checkAll(){
			var length = Object.keys(this.checks).length;
			if(length != this.list.length){
				for(var i in this.list){
					this.checks[this.list[i].blogSeq] = this.list[i];
				}
			} else {
				this.checks = {};
			}
			this.$forceUpdate();
		},
		setBlogStatus(status){
			if(this.list.length == 0) return alert('조회 된 블로그가 없습니다.');
			if(Object.keys(this.checks).length == 0) return alert('선택 된 블로그가 없습니다.');

			var list = [];

			if(status == 'off'){ // 블로그 노출종료
				for(var key in this.checks){
					var item1 = this.checks[key];
					if(item1.useYn == 'Y'){
						list.push(item1);
					} 
				}
				if(list.length == 0) return alert('선택된 블로그는 노출종료 상태입니다.');

			}else{ // 블로그 삭제
				for(var delKey in this.checks){
					list.push(this.checks[delKey]);
				}
			}

			this.$.popup('/adm/man/MAN906P01', {status, list})
				.then(res => {
					if(res) {
						this.getList();
					}
				});
		},

		delBlog(item){
			this.$.popup('/adm/man/MAN906P01', {status : 'del', list: [item]})
				.then(res => {
					if(res) {
						this.getList();
					}
				});
		}
	}
}
</script>